import { IconProp } from "@fortawesome/fontawesome-svg-core";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Variant } from "react-bootstrap/esm/types";
import cn from "classnames";

export interface HoverCardHeaderProps {
    id: string;
    name: string;
    icon: IconProp;
    iconVariant?: Variant;
    subtitleLabel: string;
    subtitleValue: string;
}

export const HoverCardHeader = ({ id, name, icon, iconVariant, subtitleLabel, subtitleValue }: HoverCardHeaderProps) => {
    return (
        <div className="d-flex align-items-start gap-3 py-2">
            <div className={cn("border rounded-1 flex-shrink-0 p-1", iconVariant && `text-${iconVariant} bg-${iconVariant} bg-opacity-25`)}>
                <div className="ratio ratio-1x1" style={{ width: "calc(var(--bs-body-font-size) * 1.65)" }}>
                    <FontAwesomeIcon icon={icon} />
                </div>
            </div>
            <div className="d-flex flex-column fs-7">
                <span className="m-0 fw-bold text-break" id={`${id}-name`}>
                    {name}
                </span>
                <div className="m-0 text-break fw-normal text-body opacity-70">
                    <span className="fw-bold">{subtitleLabel}: </span>
                    {subtitleValue}
                </div>
            </div>
        </div>
    );
};
